import styled from 'styled-components';


export const HighlightsTag = styled.div.attrs({
    className: 'highlights-tag'
})`
    width: 100%;
    position: relative;
    top:15px;
    /* margin-top: 20px; */
    .slide_for_advertise{
        max-height: 500px;
        width: 100%;
    }
    button {
        margin-top: 20px;
    }
    @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
        top:0px;
      }
    
`;